import { Button, Flex, Link } from '@chakra-ui/react';
import { RenderInMobile } from '@ui/components/MobileOrDesktop';
import { ModalOrDrawerBodyWithMask } from '@ui/components/ModalOrDrawer';
import { EXTERNAL_LINK } from '@ui/config/externalLinks';
import { useTranslations } from '@ui/i18n';

import { useDisclaimerDrawer } from '../DisclaimerDrawer';
import { ProtocolCard } from './ProtocolCard';
import { useUseYourTokenDrawer } from './useUseYourTokenDrawer';

export const DefaultContent = () => {
  const t = useTranslations();
  const openDisclaimerDrawer = useDisclaimerDrawer((s) => s.onOpen);
  const title = useUseYourTokenDrawer((s) => s.title);
  const protocols = useUseYourTokenDrawer((s) => s.protocols);

  return (
    <ModalOrDrawerBodyWithMask maskHeight={60}>
      {protocols.map((protocol, i) => {
        return (
          <ProtocolCard
            key={i}
            mb="16px"
            {...protocol}
            onClick={() => {
              openDisclaimerDrawer({
                url: protocol.url,
                title,
                DrawerContainer: RenderInMobile,
              });
            }}
          />
        );
      })}
      <Flex w="full" justify="center">
        <Link href={EXTERNAL_LINK.listingForm} isExternal>
          <Button mt={3} mb={4} variant="link">
            {t('List your protocol')}
          </Button>
        </Link>
      </Flex>
    </ModalOrDrawerBodyWithMask>
  );
};
